/**
 * @generated SignedSource<<bcd1f1ff9037a25aa69b33c21f39d75f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftCmsExhibitionCaptionAlignment = "center" | "left" | "%future added value";
export type NftCmsExhibitionCaptionPosition = "left" | "right" | "%future added value";
export type NftCmsExhibitionCtaStyle = "outlined" | "solid" | "%future added value";
export type NftCmsExhibitionImageSize = "full" | "half" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HtmlBannerText_htmlBannerExhibition$data = {
  readonly backgroundColor: string | null;
  readonly captionAlignment: NftCmsExhibitionCaptionAlignment | null;
  readonly captionPosition: NftCmsExhibitionCaptionPosition | null;
  readonly color: string | null;
  readonly ctaCopy: string | null;
  readonly ctaHref: string | null;
  readonly ctaStyle: NftCmsExhibitionCtaStyle | null;
  readonly curator: string | null;
  readonly dek: string | null;
  readonly eyeBrow: string | null;
  readonly header: string | null;
  readonly imageSize: NftCmsExhibitionImageSize | null;
  readonly " $fragmentType": "HtmlBannerText_htmlBannerExhibition";
};
export type HtmlBannerText_htmlBannerExhibition$key = {
  readonly " $data"?: HtmlBannerText_htmlBannerExhibition$data;
  readonly " $fragmentSpreads": FragmentRefs<"HtmlBannerText_htmlBannerExhibition">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HtmlBannerText_htmlBannerExhibition",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "captionPosition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "captionAlignment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eyeBrow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dek",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "curator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaStyle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaCopy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaHref",
      "storageKey": null
    }
  ],
  "type": "NftCmsExhibitionHtmlBannerType",
  "abstractKey": null
};

(node as any).hash = "05b410cf768acbe0415096e5d25ddc24";

export default node;
